/**
 * pmThresholds.js — Seuils environnementaux équins (frontend ESM)
 * Source de vérité : shared/pmThresholds.json (copié dans src/constants/ pour CRA)
 * IMPORTANT : toute modification doit être répercutée dans shared/pmThresholds.json
 */
import data from './pmThresholds.json';

export const PM_THRESHOLDS       = data.PM_THRESHOLDS;
export const TEMP_THRESHOLDS     = data.TEMP_THRESHOLDS;
export const HUMIDITY_THRESHOLDS = data.HUMIDITY_THRESHOLDS;
export const EXPOSURE_DURATIONS  = data.EXPOSURE_DURATIONS;
// Valeur max recommandée de CO2 (D253) : repère d'affichage, jamais dérivé vers DEFAULT_ALERT_THRESHOLDS.
export const CO2_THRESHOLDS      = data.CO2_THRESHOLDS;

export const DEFAULT_ALERT_THRESHOLDS = {
  pm25:        { warningMax: PM_THRESHOLDS.pm25.warningMax, alertMax: PM_THRESHOLDS.pm25.alertMax },
  pm10:        { warningMax: PM_THRESHOLDS.pm10.warningMax, alertMax: PM_THRESHOLDS.pm10.alertMax },
  temperature: { warningLow: TEMP_THRESHOLDS.warningLow, warningHigh: TEMP_THRESHOLDS.warningHigh, alertLow: TEMP_THRESHOLDS.alertLow, alertHigh: TEMP_THRESHOLDS.alertHigh },
  humidity:    { warningLow: HUMIDITY_THRESHOLDS.warningLow, warningHigh: HUMIDITY_THRESHOLDS.warningHigh, alertLow: HUMIDITY_THRESHOLDS.alertLow, alertHigh: HUMIDITY_THRESHOLDS.alertHigh },
  exposureDuration: { temp_minutes: EXPOSURE_DURATIONS.temp_minutes, hum_minutes: EXPOSURE_DURATIONS.hum_minutes },
};

/**
 * Baseline journalière indicative pour l'exposition cumulée (AUC), en µg/m³·h/jour.
 *
 * POURQUOI une fonction dérivée et non un littéral : c'est une grandeur DÉRIVÉE absente
 * du JSON brut (= concentration de référence PM2.5 « bon » × durée d'exposition
 * journalière de référence). Centralisée ici pour (1) supprimer le chiffre magique « 600 »
 * dupliqué à l'écran (AucChart) et dans le PDF (pdfCharts), et (2) suivre automatiquement
 * toute évolution des seuils sourcés (shared/pmThresholds.json) sans dérive silencieuse.
 * Valeur actuelle : 25 µg/m³ × 24 h = 600. (pm25.good === pm25.warningMax dans le JSON.)
 */
export function getAucBaselineDay() {
  return PM_THRESHOLDS.pm25.good * EXPOSURE_DURATIONS.pm_hours;
}
